// router.js
import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store/index'
import {getSaiShiApiOne} from "@/service/api/teamPlayerManagement";

// 定义路由
const routes = [
    //小程序扫码提示页面
    {
        path: '/promptPage',
        component: () => import("@/view/PromptPage"),
        meta: { title: '提示' }
    },
    {
        path: '/',
        component: () => import("@/ManageRoot"),
        children:[
            {
                path: '/',
                component: () => import("@/view/EventManagement"),
            },
            {
                path: '/AdministratorManagement',
                component: () => import("@/view/AdministratorManagement"),
            },
            {
                path: '/WechatManagement',
                component: () => import("@/view/WechatManagement"),
            },
            {
                path: '/HomeRecommendation',
                component: () => import("@/view/HomeRecommendation"),
            },
            {
                path: '/DistributorManagement',
                component: () => import("@/view/DistributorManagement"),
            },
            {
                path: '/DataDictionary',
                component: () => import("@/view/DataDictionary"),
            },
        ]
    },
    {
        path: '/login',
        component: () => import("@/LoginView"),
    },
    {
        path: '/EventManageRoot',
        component: () => import("@/EventManageRoot"),
        redirect: '/RealTimeKanban',
        children: [
            {
                path: '/RealTimeKanban',
                component: () => import('@/view/EventManageRoot/RealTimeKanban')
            },
            {
                path: '/competitiveEvent',
                component: () => import('@/view/EventManageRoot/CompetitiveEvent')
            },
            {
                path: '/groupManagement',
                component: () => import('@/view/EventManageRoot/GroupManagement')
            },
            {
                path: '/pointManagement',
                component: () => import('@/view/EventManageRoot/PointManagement')
            },
            {
                path: '/DistributorEvent', //分销商管理
                component: () => import('@/view/EventManageRoot/DistributorManagement')
            },
            {
                path: '/InvitationCodeManagement', //邀请码管理
                component: () => import('@/view/EventManageRoot/InvitationCodeManagement')
            },
            {
                path: '/OrderManagement', //邀请码管理
                component: () => import('@/view/EventManageRoot/OrderManagement')
            },
            {
                path: '/ExecutiveOfficer', //执裁人员管理
                component: () => import('@/view/EventManageRoot/DistributorEvent')
            },
            {
                path: '/PasswordUsage', //口令使用记录
                component: () => import('@/view/EventManageRoot/PasswordUsage')
            },
            {
                path: '/TeamPlayerManagement', //队伍队员管理
                component: () => import('@/view/EventManageRoot/TeamPlayerManagement')
            },
            {
                path: '/RaceBagCollection', //赛事包领取记录
                 component: () => import('@/view/EventManageRoot/RaceBagCollection')
            },
            {
                path: '/PunchingCard', //打卡记录
                component: () => import('@/view/EventManageRoot/PunchingCard')
            },
            {
                path: '/lineManagement',
                component: () => import('@/view/EventManageRoot/LineManagement')
            },
            {
                path: '/OrderManagement',
                component: () => import('@/view/EventManageRoot/OrderManagement')
            },
            {
                path: '/couponManagement',
                component: () => import('@/view/EventManageRoot/CouponManagement')
            },
            {
                path: '/textMessageAlert',
                component: () => import('@/view/EventManageRoot/TextMessageAlert')
            },
        ]
    },
    {
        path: '/test',
        component: () => import("@/view/test"),
    }
];

// 创建router实例
const router = createRouter({
    // history: createWebHistory('/match/'),
    history: createWebHistory(),
    routes,
});

export default router;


router.beforeEach(async (to, from, next) => {
    if (!to.href.includes("promptPage")) {
        //如果是登录页面路径，就直接next()
        if (window.localStorage.getItem("competition-management-userInfo")) {

            //获取本地存储信息，并转换为Json格式
            const userData = JSON.parse(window.localStorage.getItem("competition-management-userInfo"));
            //判断有没有token
            if (
                userData.token !== "" &&
                userData.token !== undefined &&
                userData.token !== null
            ) {
                if (to.query.id) {
                    const res = await getSaiShiApiOne(to.query.id)
                    if (res.code === 200) {
                        document.title = res.data.title
                        await store.dispatch('fetchMatchId', res.data.id);
                        await store.dispatch('fetchMatchTitle', res.data.title);
                        await store.dispatch('fetchMatchStatus', res.data.matchStatus);
                    }
                }
                //返回上一层路由
                next();
            }
        } else {
            if (to.path === "/login") {
                next();

            } else {
                next("/login");
            }
        }
    } else {
        next();
    }
});
